import { Box, CircularProgress, Skeleton, Typography } from "@mui/material";
import BookingStatusTabs from "./booking-status-tabs";
import useQuery from "utils/router.util";
import { useAppSelector } from "store/appHooks";
import RentalBookingRequestItem from "./booking-item";

const RentalBookings = () => {
  const query: any = useQuery();
  const { rentalsReducer } = useAppSelector((state) => state);
  const { list, loadingList } = rentalsReducer;
  return (
    <Box sx={{ borderRight: "1px solid #E2E2E2", minHeight: "60vh" }}>
      <Box
        sx={{
          padding: "20px 0 0 60px",
          borderBottom: "1px solid #E2E2E2",
          display: {
            sm: "none",
            xs: "none",
            md: "block",
            lg: "block",
            xl: "block",
          },
          background: "#F4F4F4",
        }}
      >
        <Typography
          sx={{
            color: "#323232",
            fontSize: "24px",
            fontWeight: 600,
            lineHeight: "35px",

            mb: "10px",
          }}
        >
          Bookings
        </Typography>
        <BookingStatusTabs tab={query.get("type") || "pending"} />
      </Box>
      <Box
        sx={{
          padding: "10px 15px",
          borderBottom: "1px solid #E2E2E2",
          display: {
            sm: "flex",
            xs: "flex",
            md: "none",
            lg: "none",
            xl: "none",
          },
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: "#323232",
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "35px",
          }}
        >
          Bookings
        </Typography>
        <BookingStatusTabs
          selection={true}
          tab={query.get("type") || "pending"}
        />
      </Box>
      <Box
        pb="40px"
        sx={{ background: "#FFF", overflow: "auto", height: "65vh" }}
      >
        {list.map((d: any) => (
          <RentalBookingRequestItem {...d} />
        ))}
        {loadingList && (
          <Box
            sx={{
              width: "100%",
              // display: "flex",
              // justifyContent: "center",
              // alignItems: "center",
              my: "30px",
            }}
          >
            {[1, 2, 3, 4, 5].map(() => (
              <Skeleton
                variant="rectangular"
                height={100}
                width="100%"
                sx={{ mb: "15px" }}
              />
            ))}
          </Box>
        )}
        {list.length === 0 && !loadingList && (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "50vh",
            }}
          >
            <Typography
              sx={{ color: "#A2A2A2", fontWeight: 500, fontSize: "16px" }}
            >
              No Listing Yet!
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default RentalBookings;
